import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'

// Wealthbox client linking is handled by the existing sync flow (no manual
// link dialog like Redtail). When a Summit client has no Wealthbox account
// row in `levels.integrationsLevels`, the smart component just renders this
// message — there is no inline "link" action for the user to take here.
const useStyles = makeStyles({
  root: {
    minHeight: ({ minHeight }) => minHeight
  }
})

function NotLinkedInline ({ minHeight }) {
  const classes = useStyles({ minHeight })

  return (
    <div className={clsx(classes.root, 'flex flex-col items-center justify-center text-center gap-xs p-sm')}>
      <p className='font-size-sm my-0' style={{ color: 'var(--text-color-subtle)' }}>
        Client is not linked to Wealthbox
      </p>
    </div>
  )
}

NotLinkedInline.propTypes = {
  minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default NotLinkedInline
